import { graphql } from '@/graphql-setup'

export const DRIVER_GRADE_MONTH_QUERY = graphql(`
  query DriverGradeMonth($month: Date!) {
    driverGradeMonth(month: $month) {
      scoreVersion
      maximumGrade
      rows {
        user {
          id
          fullName
        }
        grade
        days
        distanceKm
        bestGrade
        worstGrade
        metrics {
          key
          value
          score
          weight
          bandLow
          bandHigh
          higherIsBetter
          bestValue
          pointsToGain
        }
      }
    }
  }
`)

export const DRIVER_GRADE_DAYS_QUERY = graphql(`
  query DriverGradeDays($user: ID!, $month: Date!) {
    driverGradeDays(user: $user, month: $month) {
      date
      grade
      distanceKm
      metrics {
        key
        value
        score
        weight
        bandLow
        bandHigh
        higherIsBetter
        bestValue
        pointsToGain
      }
    }
  }
`)

export const DRIVER_GRADE_DAY_DETAIL_QUERY = graphql(`
  query DriverGradeDayDetail($user: ID!, $date: Date!) {
    driverGradeDayDetail(user: $user, date: $date) {
      date
      grade
      skippedReason
      distanceKm
      maximumGrade
      scoreVersion
      metrics {
        key
        value
        score
        weight
        bandLow
        bandHigh
        higherIsBetter
        bestValue
        pointsToGain
      }
      segments {
        datetimeStart
        datetimeEnd
        metrics {
          key
          tone
        }
      }
      stretches {
        metricKey
        firstSegment
        lastSegment
        datetimeStart
        datetimeEnd
        value
        score
        tone
      }
      routes {
        vehicleVin
        vehicleRegistrationNumber
        coordinates {
          lat
          lng
          timestamp
        }
      }
      observations {
        key
        value
        unavailableReason
      }
      overspeedEvents {
        datetimeStart
        datetimeEnd
        vehicleVin
        vehicleRegistrationNumber
        maxSpeed
        authorisedSpeed
      }
    }
  }
`)
